import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { setSelectedPlanType, setSelectAllPlan } from '../../../actions/plan';
import { clearMapFilters, filterMapEgList } from '../../../actions/map';
import { selectedEquipmentGroup, setSelectedEG } from '../../../actions/equipment-group';
import { PLAN_TYPE_COLOURS, PLAN_TYPE_LIST as planTypeList } from '../../../constants/index';
import { Avatar } from '../../widgets';
import '../../../../assets/scss/seed-history.scss';
import { planAnalyzeInfo } from '../../../actions/analyze';

const PlanTypeSelection = () => {
    const [show, setShow] = useState(false);
    const [planId, setPlanId] = useState(0);    
    const location = useLocation();
    const dispatch = useDispatch();
    const params = useParams();
    const farmId = params.farmId;
    
    const loadHistoryUrlsName = [`loadhistory`, `seedhistory`, `logisticshistory`]
    const hasLoadHistory = loadHistoryUrlsName.some(urlName => location.pathname.includes(urlName));

    const prevSelectedPlan = useSelector(state => state.user.userSettings.plan_type_id); // api save
    const currentSelectPlan = useSelector(state => state.plan.selectedPlanType);

    useEffect(() => {
        dispatch(setSelectedPlanType(prevSelectedPlan));
    }, [prevSelectedPlan]);

    useEffect(() => { setPlanId(currentSelectPlan); }, [currentSelectPlan]);

    // useEffect(() => {
    //     setPlanId(currentSelectPlan);
    //     dispatch(setSelectedPlanType(currentSelectPlan));
    // }, [farmId]);

    const handleChange = plan => {
        setShow(false);
        setPlanId(plan);

        dispatch(filterMapEgList({ egIds: [] }));
        dispatch(planAnalyzeInfo(farmId));

        dispatch(clearMapFilters());
        dispatch(setSelectedEG([]));
        dispatch(selectedEquipmentGroup(null));
        dispatch(setSelectedPlanType(plan));

        if (plan === 10) dispatch(setSelectAllPlan(true));
        else dispatch(setSelectAllPlan(false));
    };

    const name = useMemo(() => {
        const selected = planTypeList.filter(e => e.plan_type_id === planId);
        return selected.length !== 0 ? selected[0] : planTypeList[0];
    }, [planId]);

    const popover = <Popover className='plan-popover'>
        <Popover.Content>
            <div className='plan-list' style={{ marginLeft: '-13px' }}>
                {planTypeList.map((plan, i) => {
                    return (
                        <div key={i}
                            style={{
                                color: plan.plan_type_id === name.plan_type_id ? PLAN_TYPE_COLOURS[plan.plan_type_id] : 'black',
                                ...plan.plan_type_id === 10 && {
                                    borderBottom: 'solid 1px #e9e9e9',
                                    paddingBottom: '4px'
                                }
                            }}
                            className='labels-list'
                            onClick={() => handleChange(plan.plan_type_id)}
                        >

                            <span className='plan-avatar'>
                                <Avatar
                                    key={plan.plan_type_id}
                                    className="img-avatar"
                                    style={{
                                        border: plan.plan_type_id === name.plan_type_id ? `3px solid` : "none",
                                        borderColor: plan.plan_type_id === name.plan_type_id ? `#ffc807` : "none"
                                    }}
                                    name={plan.plan_type.split(" ")[0]}
                                    color={PLAN_TYPE_COLOURS[plan.plan_type_id]}
                                    singleLetterAvatar={true}
                                />
                            </span>

                            <span className='selected-plan'>
                                {plan.plan_type}
                            </span>

                            {(plan.plan_type_id === 10) && <div className='divider'></div>}
                        </div>);
                })}

                {/* <Form className='plan-show-all' style={{ paddingLeft: '20px' }}>
                    <Form.Check
                        type="switch"
                        id="plan-show-all"
                        label="Select All"
                        checked={isSelectAllPlan}
                        onChange={e => {
                            // dispatch(setSelectedPlanType(0))
                            dispatch(setSelectAllPlan(e.target.checked))
                        }}
                    />
                </Form> */}

            </div>
        </Popover.Content>
    </Popover>;

    return (
        <div className={`plan-menu ${hasLoadHistory ? 'd-none' : ''}`}>
            <OverlayTrigger
                show={show}
                onToggle={toggle => setShow(toggle)}
                trigger="click"
                placement="bottom-end"
                delay={{ show: 1000 }}
                overlay={popover} >
                <div className='selected_plan_name'>
                    <span className='plan-avatar'>
                        <Avatar
                            key={name.plan_type_id}
                            className="img-avatar"
                            style={{
                                border: `3px solid`,
                                borderColor: `#ffc807`
                            }}
                            name={name.plan_type.split(" ")[0]}
                            color={PLAN_TYPE_COLOURS[name.plan_type_id]}
                            singleLetterAvatar={true}
                        />
                    </span>
                </div>
            </OverlayTrigger>
        </div>
    );
};

export default PlanTypeSelection;